import React, { useState } from 'react';
import { Path } from 'slate';
import { ReactEditor } from 'slate-react';

import { clearEditorMenu } from '../../../../actions/clearEditorMenu';
import { useDispatch } from '../../../../redux';
import { updateLinkElement } from '../internal/withLinks';
import { LinkEdit } from './LinkEdit';

type Props = {
  editor: ReactEditor;
  initialUrl: string;
  initialText: string;
  linkElementPath: Path;
};

type State = {
  url: string;
  text: string;
};

export const LinkEditContainter = ({ editor, initialUrl, initialText, linkElementPath }: Props): React.ReactElement => {
  const [state, setState] = useState<State>(() => ({ url: initialUrl, text: initialText }));
  const dispatch = useDispatch();

  return (
    <LinkEdit
      value={{ text: state.text, url: state.url }}
      onChange={(value): void => {
        setState((state) => ({ ...state, ...value }));
      }}
      onSave={(): void => {
        updateLinkElement(editor, linkElementPath, { url: state.url, text: state.text });
        ReactEditor.focus(editor);
        dispatch(clearEditorMenu());
      }}
    />
  );
};
